/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  ScheduleTemplateRestService,
  ScheduleTemplateStatus,
  ScheduleType,
} from '@gh/builder-shared-data';
import { InitDialogViewService } from '@gh/common-shared';
import { EmptyDialogInput } from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { ScheduleTemplateListItem } from './schedule-list.model';

@Injectable()
export class WorksheetTemplateDialogBusinessService implements InitDialogViewService<EmptyDialogInput> {
  constructor(private scheduleTemplateRest: ScheduleTemplateRestService) {
  }

  initDialogView(): any {
    return {
      templates: this.scheduleTemplateRest.findAll({
        type: ScheduleType.PreConstruction,
      }).pipe(map$((templates) => templates.filter(({ active }) => active === ScheduleTemplateStatus.Active))),
    };
  }

  setDefaultTemplate(template: ScheduleTemplateListItem): Observable<void> {
    return this.scheduleTemplateRest.setDefaultForWorksheet(template);
  }
}
